const variables = {
  mainNavigationLargeHeight: 128,
  mainNavigationLargeMarginTop: 0,
  mainNavigationLargeProfileMenuButtonVariant: 'ghost',
  mainNavigationSmallHeight: 56,
  mainNavigationSmallMarginTop: 0,
  mainNavigationSmallProfileMenuButtonVariant: 'ghost',
};

export default variables;
